import { render, staticRenderFns } from "./projects-tabs.vue?vue&type=template&id=518063e0&scoped=true&"
import script from "./projects-tabs.vue?vue&type=script&lang=js&"
export * from "./projects-tabs.vue?vue&type=script&lang=js&"
import style0 from "./projects-tabs.vue?vue&type=style&index=0&id=518063e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518063e0",
  null
  
)

export default component.exports